'use strict';

const util = require('../../utils/util');
const showLoading = require('../../utils/showLoading');
const Ajax = require('../../utils/ajax');
const Progress = require('../../utils/progress');
const adyenCse = require('../../components/checkout/adyen-cse');
const formPrepare = require('./formPrepare');
const klarnaWidget = require('./klarna/klarna-widget');
const uniform = require('../../components/uniform');
const applePay = require('../checkout/applepay_ui');
const adyenComponents = require('./adyen/adyen_components');

function payNextSuccessCallback(response) {
    var paymentToken = response.PaymentToken;
    var $selectPaymentMethod = $('.payment-method-options');
    var selectedPaymentMethod = $selectPaymentMethod.find('.payment-method-radio:checked').val();
    var $paynextWidgetContainer = $('#payNextWidgetContent_' + selectedPaymentMethod);
    var $errorContainer = $('#paynext-errors');

    if ($errorContainer.length > 0) {
        $errorContainer.empty();
    }

    if (paymentToken && $paynextWidgetContainer.length > 0) {
        if (!window.payNext.succeeded) {
            window.payNext.succeeded = true;
            $('.checkout-payment-form').find('.checkout-payment-token').val(paymentToken);
            $('#checkout-billing-submit').unbind('click');
            $('#checkout-billing-submit').click();
        }
    }
}

function payNextErrorCallback(response) {
    var errors;
    var $errorContainer = $('#paynext-errors');
    var $innerErrorContainer = $errorContainer.find('.paynext-error');
    var i;

    if ($innerErrorContainer.length > 0) {
        $innerErrorContainer.empty();
    } else {
        $errorContainer.append($('<div class="message error-form paynext-error"></div>'));
        $innerErrorContainer = $errorContainer.find('.paynext-error');
    }

    if (response.Error.InnerErrors) {
        errors = $.makeArray(response.Error.InnerErrors);
        for (i = 0; i < errors.length; i++) {
            $innerErrorContainer.append(errors[i].Message);
            $innerErrorContainer.append('<br/>');
        }
    } else {
        $innerErrorContainer.html(response.Error.Message);
    }

    $('html, body').animate(
        {
            scrollTop: $('#paynext-errors').offset().top - 150
        },
        300
    );

    Progress.hide();
}

function payNextRenderErrorCallback(error) {
    console.log('payNextRenderErrorCallback');
    console.log(error);
}

function getWidgetApiOptions(widgetConf) {
    var widgetApiOptions = new window.Arvato.PayNext.WidgetApiOptions();
    widgetApiOptions.tokenizationServiceUrl =
        widgetConf.host + '/' + widgetConf.merchantId + '/Pmg.Site/WidgetApi/Home/Index';
    widgetApiOptions.securityToken = widgetConf.merchantToken;
    widgetApiOptions.placeHolder = widgetConf.contentSelector;
    widgetApiOptions.countryCode = widgetConf.countryCode;
    widgetApiOptions.currencyCode = widgetConf.currencyCode;
    widgetApiOptions.culture = widgetConf.culture;
    widgetApiOptions.cssUrl = widgetConf.cssURL;
    widgetApiOptions.displayPaymentMethodsLogo = false;
    widgetApiOptions.displayValidationErrors = false;
    widgetApiOptions.paymentMethods = widgetConf.widgetPaymentMethods;
    widgetApiOptions.clearFrameAfterSuccessfulPayment = true;
    widgetApiOptions.frameWidth = widgetConf.width;
    widgetApiOptions.frameHeight = widgetConf.height;
    widgetApiOptions.timeOut = 0; // 3000;
    widgetApiOptions.showCvcHint = false; // optional; default false; optional
    widgetApiOptions.busyIndicator = true; // optional; if "0" or "no" no busy indicator will be in place
    widgetApiOptions.renderErrorCallback = payNextRenderErrorCallback;
    widgetApiOptions.renderSuccessCallback = ''; // not implemented yet
    widgetApiOptions.errorCallback = payNextErrorCallback;
    widgetApiOptions.successCallback = payNextSuccessCallback;

    return widgetApiOptions;
}

function togglePaymentWidgetComponent() {
    var $selectPaymentMethod = $('.payment-method-options');
    var $giftCertPaymentMethod = $('#dwfrm_giftcert_redemption_giftCertID');
    $selectPaymentMethod.find('.component').hide();
    $selectPaymentMethod
        .find('.payment-method-radio:checked')
        .closest('.payment-method-option')
        .find('.component')
        .show();
    if ($selectPaymentMethod.find('.payment-method-radio:checked').attr('id') == 'is-AFTERPAY_PBI') {
        $giftCertPaymentMethod.prop('disabled', true);
        $giftCertPaymentMethod.closest('input[type="submit"]').prop('disabled', true);
        $('.gift-certificate-disabled-message').show();
    } else {
        if ($giftCertPaymentMethod.prop('disabled') == true) {
            $giftCertPaymentMethod.prop('disabled', false);
            $giftCertPaymentMethod.closest('input[type="submit"]').prop('disabled', false);
            $('.gift-certificate-disabled-message').hide();
        }
    }
}

function togglePaymentDescription() {
    var $selectPaymentMethod = $('.payment-method-options');
    $selectPaymentMethod.find('.paymentmethod-description').hide().attr('aria-hidden', 'false');
    $selectPaymentMethod
        .find('.payment-method-radio:checked')
        .closest('.payment-method-option')
        .find('.paymentmethod-description')
        .attr('aria-hidden', 'true')
        .show();
}

function handleCommonSubmit(event, $selectPaymentMethod, selectedPaymentMethod, isPaynext, widgetConf) {
    var existingPaymentToken;
    var existingPaymentCvn;
    var $existingPaymentCvnContainer;
    var $existingPaymentCvnInput;

    // check if existing payment was selected, validate cvn use existing payment token
    existingPaymentToken = $selectPaymentMethod.find('.payment-method-saved-creditcard-radio:checked').val();
    if (existingPaymentToken && selectedPaymentMethod === 'CREDIT_CARD') {
        $existingPaymentCvnContainer = $selectPaymentMethod
            .find('.payment-method-saved-creditcard-radio:checked')
            .closest('.payment-method-saved-creditcard');
        $existingPaymentCvnInput = $existingPaymentCvnContainer.find('.saved-creditcard-cvn input');
        existingPaymentCvn = $existingPaymentCvnInput.val();
        if (
            existingPaymentCvn &&
            $.isNumeric(existingPaymentCvn) &&
            existingPaymentCvn.length <= parseInt($existingPaymentCvnInput.attr('maxLength'), 10) &&
            existingPaymentCvn.length >= parseInt($existingPaymentCvnInput.attr('minLength'), 10)
        ) {
            $('.checkout-payment-form').find('.checkout-payment-token').val(existingPaymentToken);
            $('.checkout-payment-form').find('.checkout-payment-cvn').val(existingPaymentCvn);
            $('#checkout-billing-submit').unbind('click');
            $('#checkout-billing-submit').click();
        } else {
            event.preventDefault();
            $existingPaymentCvnContainer.find('.saved-creditcard-cvn').addClass('validation-error');
            $existingPaymentCvnContainer.find('.error-msg-inner').show().html(Resources.VALIDATE_NUMBER);
            $existingPaymentCvnContainer.find('.error-msg').show();
            $('html, body').animate(
                {
                    scrollTop: $('.payment-method-saved-creditcard-radio:checked').offset().top - 150
                },
                1000
            );
        }
    } else {
        // handling for new credit card entry
        if (isPaynext) {
            event.preventDefault();
        }
        $('.checkout-payment-form').find('.checkout-payment-token').val('');
        $('.checkout-payment-form').find('.checkout-payment-cvn').val('');
        if (isPaynext) {
            window.payNext[widgetConf.paymentMethod].tokenize();
        }
        // $('iframe#ArvatoPayNextWidgetApi_' + widgetConf.contentSelector).height(750);
    }
}

function initCommon() {
    togglePaymentWidgetComponent();

    $('.paymentmethod-selection .input-radio').change(function () {
        togglePaymentWidgetComponent();
    });

    $('.step.active').attr('aria-current', 'step');
}

function initPayNext() {
    var $paynextWidgetContainers = $('.paynext-widget');
    var firstWidgetConf;
    var widgetAPI;

    if ($paynextWidgetContainers.length > 0) {
        firstWidgetConf = $paynextWidgetContainers.first().data('widget-configuration');
        widgetAPI = firstWidgetConf.host + '/' + firstWidgetConf.merchantId + firstWidgetConf.widgetAPI;

        $.getScript(widgetAPI, function () {
            $paynextWidgetContainers.each(function () {
                var widgetConf = $(this).data('widget-configuration');
                var widgetApiOptions = getWidgetApiOptions(widgetConf);

                if (!window.payNext) {
                    window.payNext = {};
                }
                window.payNext[widgetConf.paymentMethod] = new window.Arvato.PayNext.WidgetApi(widgetApiOptions);
                window.payNext[widgetConf.paymentMethod].render();

                $('#checkout-billing-submit').click(function (event) {
                    var $selectPaymentMethod = $('.payment-method-options');
                    var selectedPaymentMethod = $selectPaymentMethod.find('.payment-method-radio:checked').val();

                    if (selectedPaymentMethod === widgetConf.paymentMethod) {
                        handleCommonSubmit(event, $selectPaymentMethod, selectedPaymentMethod, true, widgetConf);
                    }
                }); // end bind checkout-billing-submit
            });
        });
    }
}

/**
 * @function
 * @description Expands the gift card accordion view on initial load
 */
function initGiftCardAccordionSection() {
    var $cartGiftCertifcateInfo = $('.cart-gift-certificate-info').first();

    if ($cartGiftCertifcateInfo.length) {
        var accordionToggleData = $cartGiftCertifcateInfo.data('gift-accordion-toggle-attributes');

        if (accordionToggleData && accordionToggleData.length) {
            var accordionToggleViews = accordionToggleData.split(' ');

            accordionToggleViews.forEach(element => {
                if (
                    (element === 'giftAccordionInitMobile' && util.isMobileOrTablet()) ||
                    (element === 'giftAccordionInitDesktop' && !util.isMobileOrTablet())
                ) {
                    $cartGiftCertifcateInfo.addClass('is-expanded');
                    var $cartGiftCertifcateHint = $('.cart-gift-certificate-hint').first();
                    $cartGiftCertifcateHint.attr('aria-expanded', 'true');
                }
            });
        }
    }
}

// init Invoice Tracking
function initInvoiceTracking() {
    if ($('#disableSelectionOrder').length || $('#enableSelectionOrder').length) {
        var gtmTracker = require('../../components/tracking/tracking');

        gtmTracker.trackSubmitCheckoutEvenInvoiceDisabled('selectionOrder', false);

        $('#checkout-billing-submit').on('click', function () {
            gtmTracker.trackSubmitCheckoutEvenInvoiceDisabled('selectionOrder', true);
        });
    }

    if ($('#disableInvoiceByValue').length || $('#enableInvoiceByValue').length) {
        var gtmTracker = require('../../components/tracking/tracking');

        gtmTracker.trackSubmitCheckoutEvenInvoiceDisabled('invoiceByValue', false);

        $('#checkout-billing-submit').on('click', function () {
            gtmTracker.trackSubmitCheckoutEvenInvoiceDisabled('invoiceByValue', true);
        });
    }
}

// init authorize net credit card if required
function initCreditCard() {
    var $ccArea = $('.jsANCC');
    if ($ccArea.length > 0) {
        $('.component-CREDIT_CARD input[type=radio]').on('change', function (e) {
            var val = $(e.target).val();
            if (val) {
                $ccArea.hide();
            } else {
                $ccArea.slideDown();
            }
            // re-validate the form
            // ccArea.closest('form').validate().form();
            // formPrepare.validateForm();
        });

        $('#checkout-billing-submit').click(function (event) {
            var $selectPaymentMethod = $('.payment-method-options');
            var selectedPaymentMethod = $selectPaymentMethod.find('.payment-method-radio:checked').val();

            if (adyenComponents.handleIfComponent(event)) {
                return;
            }

            if (selectedPaymentMethod === 'CREDIT_CARD') {
                handleCommonSubmit(event, $selectPaymentMethod, selectedPaymentMethod, false, null);
            }
        });
    }
}

/**
 * @function
 * @description Fills the Credit Card form with the passed data-parameter and clears the former cvn input
 * @param {Object} data The Credit Card data (holder, type, masked number, expiration month/year)
 */
/* function setCCFields(data) {
    var $creditCard = $('[data-method="CREDIT_CARD"]');
    $creditCard.find('input[name$="creditCard_owner"]').val(data.holder).trigger('change');
    $creditCard.find('select[name$="_type"]').val(data.type).trigger('change');
    $creditCard.find('input[name*="_creditCard_number"]').val(data.maskedNumber).trigger('change');
    $creditCard.find('[name$="_month"]').val(data.expirationMonth).trigger('change');
    $creditCard.find('[name$="_year"]').val(data.expirationYear).trigger('change');
    $creditCard.find('input[name$="_cvn"]').val('').trigger('change');
} */

/**
 * @function
 * @description Changes the payment method form depending on the passed paymentMethodID
 * @param {String} paymentMethodID the ID of the payment method, to which the payment method form should be changed to
 */
function updatePaymentMethod(paymentMethodID, initial) {
    var $paymentMethods = $('.payment-method');
    var $selectedPaymentMethod;
    var $requiredCardFields = $('.payment-method-new-creditcard .required');

    $paymentMethods.removeClass('payment-method-expanded');

    $selectedPaymentMethod = $paymentMethods.filter('[data-method="' + paymentMethodID + '"]');
    if ($selectedPaymentMethod.length === 0) {
        $selectedPaymentMethod = $('[data-method="Custom"]');
    }
    $selectedPaymentMethod.addClass('payment-method-expanded');

    // ensure checkbox of payment method is checked
    // $('input[name$="_selectedPaymentMethodID"]').removeAttr('checked');
    // $('input[value=' + paymentMethodID + ']').prop('checked', 'checked');

    if (initial !== true) {
        // Clear old new credit card form errors
        $('.payment-method-new-creditcard .form-row.validation-error').removeClass('validation-error');

        // Do not highlight missing fields from credit card form on initial payment selection
        $requiredCardFields.removeClass('required');
        formPrepare.validateForm();
        $requiredCardFields.addClass('required');
    }
}

/**
 * @function
 * @description Changes the payment type or issuerId of the selected payment method
 * @param {String, Boolean} value of payment type or issuerId and a test value to see which one it is, to which the payment type or issuerId should be changed to
 */
function updatePaymentType(selectedPayType, test) {
    if (!test) {
        $('input[name="brandCode"]').removeAttr('checked');
    } else {
        $('input[name="issuerId"]').removeAttr('checked');
    }

    $('input[value=' + selectedPayType + ']').prop('checked', 'checked');
    formPrepare.validateForm();
}

function updateCTA(selectedPaymentMethod) {
    var selectedMethod = selectedPaymentMethod.find('.payment-method-radio:checked');
    var isPaynextEnabled = $('#payNextWidgetContent_PAYPAL').length > 0;
    if (
        (!selectedMethod.length > 0 && !$('.gift-cert-used').length > 0) ||
        (selectedMethod.val() == 'PAYPAL' && !isPaynextEnabled)
    ) {
        $('#checkout-billing-submit').prop('disabled', true);
        if (!isPaynextEnabled && selectedMethod.val() == 'PAYPAL') {
            $('#checkout-billing-submit').parent().hide();
            $('.paypal-continue').show();
        }
    } else {
        $('#checkout-billing-submit').prop('disabled', false).parent().show();
        $('.paypal-continue').hide();
    }
}

/**
 * @function
 * @description loads billing address, Gift Certificates, Coupon and Payment methods
 */
exports.init = function (reInit) {
    const giftSelector = '.gift-cert-redemption-id';
    var $body = $('body');
    var $checkoutForm = $('.checkout-billing');
    var $addCoupon = $('#add-coupon');
    var $couponCode = $('input[name$="_couponCode"]');
    var $selectPaymentMethod = $('.payment-method-options');
    var $payType = $('[name="brandCode"]');
    var $issuerId = $('[name="issuerId"]');
    var $issuer = $('ul#issuer');
    var selectedPayType = $payType.find(':checked').val();
    var selectedIssuerId = $issuerId.find(':checked').val();
    var selectedPaymentMethod = $selectPaymentMethod.find('.payment-method-radio:checked').val();
    var formToSubmit = document.getElementById('dwfrm_billing');
    var button = document.getElementById('checkout-billing-submit');
    var $gcApplyButton = $('#ApplyGiftCertificateButton');

    klarnaWidget.init();
    applePay.init();

    showLoading.showLoading(formToSubmit, button);

    formPrepare.init({
        formSelector: 'form[id$="billing"]',
        continueSelector: '[name$="cobilling_save"]',
        skipInitialValid: true
    });

    $body.on('change', function () {
        updateCTA($selectPaymentMethod);
    });

    $(document).ready(function () {
        updateCTA($selectPaymentMethod);
    });

    if (!reInit) {
        $body.on('change', '.payment-method-saved-creditcard-radio', function () {
            var $cvnContainers = $('.saved-creditcard-cvn');
            var $currentCvnContainer;
            $cvnContainers.hide();
            $cvnContainers.removeClass('validation-error');
            $cvnContainers.find('input').val('').attr('disabled', 'disabled');
            $currentCvnContainer = $(this).closest('.payment-method-saved-creditcard').find('.saved-creditcard-cvn');
            if ($(this).is(':checked')) {
                $currentCvnContainer.find('input').removeAttr('disabled');
                $currentCvnContainer.show();
            }
        });
    }

    initCommon();
    initPayNext();
    initInvoiceTracking();
    initCreditCard();
    initGiftCardAccordionSection();

    if ($(formToSubmit).data('billingconfig') && $(formToSubmit).data('billingconfig').enableAdyenCSE) {
        adyenCse.initBilling();
    }

    // default payment method to 'CREDIT_CARD'
    updatePaymentMethod(selectedPaymentMethod || 'CREDIT_CARD', true);
    if (!reInit) {
        $selectPaymentMethod.on('click', 'input[type="radio"]', function () {
            if ($(this).val() == 'Adyen' && $payType.length > 0) {
                // set payment type of Adyen to the first one
                updatePaymentType(selectedPayType || $payType[0].value, false);
            } else if ($(this).val() == 'PAYPAL' && !($('#payNextWidgetContent_PAYPAL').length > 0)) {
                $('.checkout-continue').hide();
                $('#checkout-billing-submit').prop('disabled', true);
            } else {
                $payType.removeAttr('checked');
                $issuerId.removeAttr('checked');
            }

            // updatePaymentMethod($(this).val(), false);
        });

        $payType.on('click', function () {
            updatePaymentType($(this).val(), false);
            // if the payment type contains issuerId fields, expand form with the values
            if ($(this).siblings('#issuer').length > 0) {
                $issuer.show();
                updatePaymentType(selectedIssuerId || $issuerId[0].value, true);
            } else {
                $issuer.hide();
                $('input[name="issuerId"]').removeAttr('checked');
            }
        });

        $issuerId.on('click', function () {
            updatePaymentType($(this).val(), true);
        });
    }

    // open first payment description by default
    togglePaymentDescription();

    if (!reInit) {
        // default payment description toggle
        $body.on('change', '.paymentmethod-selection .input-radio', function (e) {
            var selectedId = e.target.id;
            var $selectPaymentMethod = $('.payment-method-options');

            $selectPaymentMethod
                .find('.payment-method-option')
                .find('.form-row-radio')
                .find('label')
                .attr('aria-selected', 'false');

            $('label[for="' + selectedId + '"]').attr('aria-selected', 'true');

            togglePaymentDescription();
        });

        $body.on('click', '#add-coupon', function (e) {
            e.preventDefault();
            var $error = $checkoutForm.find('.coupon-error');
            var code = $couponCode.val();
            var url;
            if (code.length === 0) {
                $error.html(Resources.COUPON_CODE_MISSING);
                return;
            }

            url = util.appendParamsToUrl(Urls.addCoupon, {couponCode: code, format: 'ajax'});
            $.getJSON(url, function (data) {
                var fail = false;
                var msg = '';
                if (!data) {
                    msg = Resources.BAD_RESPONSE;
                    fail = true;
                } else if (!data.success) {
                    msg = data.message.split('<').join('&lt;').split('>').join('&gt;');
                    fail = true;
                }
                if (fail) {
                    $error.html(msg);
                    return;
                }

                // basket check for displaying the payment section, if the adjusted total of the basket is 0 after applying
                // the coupon
                // this will force a page refresh to display the coupon message based on a parameter message
                if (data.success && data.baskettotal === 0) {
                    window.location.assign(Urls.billing);
                }
            });
        });

        // trigger events on enter
        $body.on('keydown', 'input[name$="_couponCode"]', function (e) {
            if (e.which === 13) {
                e.preventDefault();
                $addCoupon.click();
            }
        });

        $body.on('click', '.cart-gift-certificate-hint', function (e) {
            $('.cart-gift-certificate-info').toggleClass('is-expanded');
            if ($('.cart-gift-certificate-info').hasClass('is-expanded')) {
                $(this).attr('aria-expanded', 'true');
            } else {
                $(this).attr('aria-expanded', 'false');
            }
        });

        $gcApplyButton.prop('disabled', true);

        $(giftSelector).bind('input propertychange', function () {
            $gcApplyButton.prop('disabled', $(this).val() === '');
        });

        $body.on('submit', 'form.gift-certificate-apply', function (event) {
            var $form = $(this);
            var $messageContainer = $form.find('.gift-certificate-apply-message');
            var $redemptionIdInput = $form.find(giftSelector);

            $messageContainer.fadeOut(300);
            event.preventDefault();
            Progress.show($form);

            Ajax.submitForm(
                $form,
                function (response) {
                    var jsonResponse = JSON.parse(response);
                    var $messageAmount = $messageContainer.find('.gift-certificate-apply-message-amount');
                    var $messageCode = $messageContainer.find('.gift-certificate-apply-message-code');

                    if (jsonResponse.success) {
                        $messageAmount.html(jsonResponse.redeemedAmount);
                        $messageCode.html(jsonResponse.certificateID);
                        $messageContainer.fadeIn(300);

                        $.get(Urls.billing, function (innerResponse) {
                            var $htmlResponse = $($(innerResponse));
                            var $paymentForm = $('.checkout-payment-form');
                            var $miniSummary = $('.checkout-mini-summary');
                            var $paymentMethods = $paymentForm.find('.payment-method-options');
                            var $selectedPaymentMethod = $paymentMethods
                                .find('.payment-method-radio:checked')
                                .closest('.payment-method-option')
                                .find('.component');
                            var checkedSelectedPaymentMethod = $paymentMethods
                                .find('.payment-method-radio:checked')
                                .attr('id');
                            $paymentForm.replaceWith($htmlResponse.find('.checkout-payment-form'));
                            var $checkedSelectedPaymentMethod = $('#' + checkedSelectedPaymentMethod);
                            $checkedSelectedPaymentMethod.prop('checked', true);
                            $selectedPaymentMethod.find(':input').each(function () {
                                var savedInputFieldId = $(this).attr('id');
                                var savedInputFieldValue = $(this).val();
                                var $savedInputFieldId = $('#' + savedInputFieldId);
                                $savedInputFieldId.val(savedInputFieldValue);
                            });

                            $miniSummary.replaceWith($htmlResponse.find('.checkout-mini-summary'));
                            $('#checkout-billing-submit').prop('disabled', false);
                            $gcApplyButton.prop('disabled', true);
                            $redemptionIdInput.val('');

                            adyenComponents.init();
                            uniform();
                            Progress.hide($form);
                            exports.init(true);
                        });
                    } else {
                        var validator = $form.validate();
                        var inputName = $redemptionIdInput.attr('name');
                        var errorObj = {};

                        errorObj[inputName] = jsonResponse.giftCertIDError;
                        validator.showErrors(errorObj);
                        Progress.hide($form);
                    }
                },
                true
            );
        });
    }

    $payType.on('click', function () {
        updatePaymentType($(this).val(), false);
        // if the payment type contains issuerId fields, expand form with the values
        if ($(this).siblings('#issuer').length > 0) {
            $issuer.show();
            updatePaymentType(selectedIssuerId || $issuerId[0].value, true);
        } else {
            $issuer.hide();
            $('input[name="issuerId"]').removeAttr('checked');
        }
    });

    $issuerId.on('click', function () {
        updatePaymentType($(this).val(), true);
    });
};
